import { Button, Grid } from "@mui/material";
import GKModal from "components/GKModal";

const AddTrialPeriod = ({ open, setOpen }) => {
  // const { handleSubmit } = useForm({
  //   defaultValues: {
  //     plantype: "",
  //   },
  // });

  return (
    <GKModal
      open={open}
      setOpen={setOpen}
      modalTitle="Add Trial Period"
      footer={
        <Grid container justifyContent="flex-end" gap={1} marginTop={2}>
          <Button
            sx={{
              fontSize: "0.7rem",
              fontFamily: '"Arial", sans-serif',
              textTransform: "none",
            }}
            variant="outlined"
            onClick={() => setOpen(false)}
          >
            Close
          </Button>
          <Button
            sx={{
              fontSize: "0.7rem",
              fontFamily: '"Arial", sans-serif',
              textTransform: "none",
            }}
            type="submit"
            form="create-FAQ-form"
            variant="contained"
          >
            {"Submit"}
          </Button>
        </Grid>
      }
    >
      <br />
      <Grid container spacing={2} justifyContent="center">
        <Grid item xs={12}>
          Enter for days
        </Grid>
      </Grid>
    </GKModal>
  );
};

export default AddTrialPeriod;
